export default __webpack_public_path__ + "static/media/fl-icon-28-pink.fc0de52d.svg";